import React, { useMemo } from "react";
import { connect } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import { createStructuredSelector } from "reselect";
import { selectSelectedEntityRole } from "store/entity/selectors";

import Loader from "../../../../components/v2/Loaders/FullScreenLoader/Loader";
import { allUserRoles } from "../../../../constants/phase";

const PrivateRoleBasedRoute = ({ entityRole, allowedRoles = [] }) => {
  const homePage = useMemo(() => {
    if (entityRole === allUserRoles.superAdmin) {
      return "/overview";
    }

    return "/dashboard";
  }, [entityRole]);

  if (entityRole) {
    if (entityRole && allowedRoles.includes(entityRole)) {
      return <Outlet />;
    } else {
      return <Navigate to={homePage} replace />;
    }
  }

  return <Loader />;
};

const mapStateToProps = createStructuredSelector({
  entityRole: selectSelectedEntityRole,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(PrivateRoleBasedRoute);
